export enum EAPP_FLOWS {
  OFFERS = 'offers',
  AUTH = 'auth',
  ONBOARDING = 'onboarding',
  SCORE = 'score',
  CALCULATE_SCORE = 'calculate-score',
  INSTALLMENTS = 'installments',
  PAYMENT = 'payment',
  ERROR = 'error',
  FQA = 'frequent-questions',
}

export enum ETRANSACTION_STATUS {
  PENDING = 'pending',
  PROCESSED = 'processed',
  CANCELED = 'canceled',
  EXPIRED = 'expired',
}
